"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateBy = void 0;
var transducers_1 = require("../transducers");
var identity = (0, transducers_1.map)(function (x) { return x; });
// tslint:disable:max-line-length
/**
 * Applies the specified [`AggregateDescriptors`]({% slug api_kendo-data-query_aggregatedescriptor %}) to the data. Returns an [`AggregateResult`]({% slug api_kendo-data-query_aggregateresult %}) instance.
 *
 * @example
 * ```ts
 * const data = [
 *    { unitPrice: 23, unitsInStock: 21 },
 *    { unitPrice: 10, unitsInStock: 12 },
 *    { unitPrice: 20, unitsInStock: 33 }
 * ];
 *
 * const result = aggregateBy(data, [
 *   { aggregate: "sum", field: "unitPrice" },
 *   { aggregate: "sum", field: "unitsInStock" }
 * ]);
 *
 * //output:
 * // {
 * //     "unitPrice": { "sum": 53 },
 * //     "unitsInStock": { "sum": 66 }
 * // }
 * ```
 * @param {T[]} data - The data on which the calculation will be executed.
 * @param {AggregateDescriptor[]} descriptors - The aggregate operations that will be executed.
 * @param {any} transformers - For internal use.
 * @returns {AggregateResult} - The aggregated result.
 * For more information, refer to the [aggregateresult](slug:api_kendo-data-query_aggregateresult) configuration.
 */
// tslint:enable:max-line-length
var aggregateBy = function (data, descriptors, transformers) {
    if (descriptors === void 0) { descriptors = []; }
    if (transformers === void 0) { transformers = identity; }
    var initialValue = {};
    if (!descriptors.length) {
        return initialValue;
    }
    var result = (0, transducers_1.exec)(transformers((0, transducers_1.aggregatesCombinator)(descriptors)), initialValue, data);
    return (0, transducers_1.expandAggregates)(result);
};
exports.aggregateBy = aggregateBy;



//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-data-query@1.7.1/~/@progress/kendo-data-query/dist/npm/grouping/aggregate.operators.js
// module id = 262
// module chunks = 0